module.exports = __webpack_public_path__ + "static/media/book_nation_t_header.b7c84e20.png";